import CustomerAppAPI from "@/app/customerAppAxios";

/**
 * @borrows InternalAPI
 */
export default class InternationalDocumentRepository extends CustomerAppAPI {
    constructor() {
        super();
        /** @type {string} */
        this.endpoint = '/v1/shipment/international-document/detail';
    }

    async getDetail(destinationCityCode) {
        try {
            const res = await this.$axios.get(`${this.endpoint}?destination_city_code=${destinationCityCode}`);
            if (res.status === 200) {
                return { data: res.data.data, err: '' };
            }
            return { data: null, err: '' };
        } catch (err) {
            console.error(err);
            return { data: null, err: this.setErrorMessage(err) };
        }
    }
}
